import { inferLiteral } from "client/utils"
import * as types from "./types"

export const setProjectSettings = (settings: types.ProjectSettings) => ({
    type: inferLiteral(types.SET_PROJECT_SETTINGS),
    settings,
})

export const updateProjectSettings = (
    section: keyof types.ProjectSettings,
    settings: types.ChangeProjectSettings,
) => ({
    type: inferLiteral(types.UPDATE_PROJECT_SETTINGS),
    data: { section, settings },
})
